import { render } from "./DeleteKeyt.vue?vue&type=template&id=317153e7"
import script from "./DeleteKeyt.vue?vue&type=script&lang=js"
export * from "./DeleteKeyt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__